import React from "react"
import Card from "./style"
export default function ImageCard({...rest}) {
  return (
    <Card {...rest}>
      <Card.CounterBlock>
        <Card.Counter>84%</Card.Counter>
        <Card.CounterBlockIcon>
          <i className="fa fa-arrow-up" />
        </Card.CounterBlockIcon>
      </Card.CounterBlock>
        <Card.Text>
          Наших выпускников уже работают.
        </Card.Text>
    </Card>
  )
}
